const customerCompositeCollections = [
  {
    sourceName: 'configuration',
    path: '$.data[*].configuration',
    relation: '1:1',
  },
  {
    sourceName: 'profile',
    path: '$.data[*].profile',
    relation: '1:1',
  },
  {
    sourceName: 'latest_nav',
    path: '$.data[*].latest_nav',
    relation: '1:1',
  },
  {
    sourceName: 'fees',
    tableName: 'fci_fund_fee',
    path: '$.data[*].fees[*]',
    relation: '1:many',
  },
  {
    sourceName: 'strong_points',
    tableName: 'tdc_fund_strong_point',
    path: '$.data[*].strong_points[*]',
    relation: '1:many',
  },
];

export function cloneCustomerCompositeCollections(collections = customerCompositeCollections) {
  return collections.map((collection) => ({ ...collection }));
}

export function groupCustomerCompositeCollections(collections = []) {
  return {
    oneToOne: collections.filter((collection) => collection.relation === '1:1'),
    oneToMany: collections.filter((collection) => collection.relation === '1:many'),
  };
}
